// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__27OwV","header":"PatientQuestionnaire_header__1djiJ","info":"PatientQuestionnaire_info__XmpWL"};